<template>
    <header class="msgbl-link-header" @click="$emit('click')">
      <VSvgIcon tag="24" size="24" :icon="icon" class="msgbl-icon"/>
      <span class="msgbl-title">{{title}}</span>
    </header>
</template>
<script>
import {VSvgIcon} from '@/modules/common/components'

export default {
  name: 'MsgblLinkHeader',
  components: {
    VSvgIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';
@import '@/assets/scss/abstract/_i18n-mixins';

.msgbl-link-header {
  display: flex;
  align-items: center;
  font-family: var(--primary-font-family);
  font-size: 12px;
  font-weight: 600;
  color: $addToListColor;
  padding: 10px;
  cursor: pointer;

  .msgbl-icon {
    @include i-margin-mirror(0, 7px);
  }
}
</style>
